/*
 *
 */

import fragment from './WaveFilter.frag.glsl';



var WaveFilter = function () {
    PIXI.AbstractFilter.call(this);

    this.passes = [this];

    this.uniforms = {
        radius:     { type: '1f', value: 0.0 },
        timeTicker: { type: '1f', value: 0.0 },
        angle:      { type: '1f', value: 0.5 },
        offset:     { type: 'v2', value: { x: 0.5, y: 0.5 } },
        direction:  { type: '1f', value: 1 },


        rand:     { type: '1f', value: 1.0 },
        timer:     { type: '1f', value: 0.0 },
        val2:     { type: '1f', value: 0.1 },
        val3:     { type: '1f', value: 0.4 },
        horizontal:     { type: '1f', value: 0.2 },
        dimensions: {type: '4fv', value: [0.5, 0.2, 0, 0]}

    }

    this.fragmentSrc = fragment;

};

WaveFilter.prototype = Object.create(PIXI.AbstractFilter.prototype);
WaveFilter.prototype.constructor = WaveFilter;

Object.defineProperties(WaveFilter.prototype, {
    offset: {
        get: function ()
        {
            return this.uniforms.offset.value;
        },
        set: function (value)
        {
            this.uniforms.offset.value = value;
        }
    },

    /**
     * This radius of the twist.
     *
     * @member {number}
     * @memberof PIXI.filters.TwistFilter#
     */
    radius: {
        get: function ()
        {
            return this.uniforms.radius.value;
        },
        set: function (value)
        {
            this.uniforms.radius.value = value;
        }
    },

    /**
     * This angle of the twist.
     *
     * @member {number}
     * @memberof PIXI.filters.TwistFilter#
     */
    angle: {
        get: function ()
        {
            return this.uniforms.angle.value;
        },
        set: function (value)
        {
            this.uniforms.angle.value = value;
        }
    },

    direction: {
        get: function ()
        {
            return this.uniforms.direction.value;
        },
        set: function (value)
        {
            this.uniforms.direction.value = value;
        }
    },

    timeTicker: {
        get: function ()
        {
            return this.uniforms.timeTicker.value;
        },
        set: function (value)
        {
            this.uniforms.timeTicker.value = value;
            this.uniforms.timer.value = value;
        }
    }

});

module.exports = WaveFilter;


/** WEBPACK FOOTER **
 ** ./src/js/controllers/filters/WaveFilter.js
 **/